import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { ViolationResult } from './types';

export const violationResultsApi = createApi({
  reducerPath: 'violationResultsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/violation-results',
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getViolationResults: builder.query<ViolationResult[], void>({
      query: () => ({
        url: '/',
      }),
    }),
  }),
});

export const { useGetViolationResultsQuery } = violationResultsApi;
